var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.862,
    height: 15.11,
    viewBox: "0 0 15.862 15.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-cross",
    "data-name": "Icon metro-cross",
    d: "M18.288,14.067h0L13.476,9.483,18.288,4.9h0a.467.467,0,0,0,.113-.168.456.456,0,0,0-.113-.5L16.015,2.066a.513.513,0,0,0-.524-.108.5.5,0,0,0-.177.108h0L10.5,6.65,5.69,2.066h0a.5.5,0,0,0-.177-.108.513.513,0,0,0-.524.108L2.716,4.231a.456.456,0,0,0-.113.5.467.467,0,0,0,.113.168h0L7.528,9.483,2.716,14.067h0a.468.468,0,0,0-.113.168.456.456,0,0,0,.113.5L4.989,16.9a.513.513,0,0,0,.524.108A.5.5,0,0,0,5.69,16.9h0L10.5,12.316,15.314,16.9h0a.5.5,0,0,0,.177.108.513.513,0,0,0,.524-.108l2.273-2.165a.456.456,0,0,0,.113-.5.467.467,0,0,0-.113-.168Z",
    transform: "translate(-2.571 -1.928)",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close_white.0c60814c2d5c64a76b8b61f575d6e29d.svg";
export { ForwardRef as ReactComponent };